<template>
    <v-dialog
            v-model="value"
            max-width="520"
    >
        <v-card>
            <v-card-title class="headline" v-text="hadSubscription? $t('accountPaymentDialog.checkout') : $t('accountPaymentDialog.freeTrial')" ></v-card-title>

            <v-card-text>

                <payment-form  :source="'website'" :sign-in-token="signInToken"   @completed="paymentCompleted"></payment-form>


            </v-card-text>

            <v-card-actions style="position: relative; z-index: 9999;">
                <v-spacer></v-spacer>

                <v-btn
                        color=" darken-1"
                        text
                        @click="close"
						style="z-index:9999"
                >
                  <span v-html="$t('accountPaymentDialog.close')"></span>

                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style>


</style>

<script>
    import PaymentForm from '../components/paymentForm'

    export default {
        name: 'Modal_AccountPayment',
        props: ['value', 'signInToken', 'hadSubscription'],
        data: () => ({}),
        methods: {

            close(){
                this.$emit('input', false);
            },
            async paymentCompleted(payload){

                this.close();
                this.value = false;

                this.$UAnalytics.subscribed();

                this.$emit('completed', payload);

            }

        },
        watch: {
            value(v){
                this.$emit('input', v);
            }
        },
        components: {
            PaymentForm
        }
    };
</script>
